// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Fosg","header":"ClearentDisclaimer_header__MYIAr","inner":"ClearentDisclaimer_inner__1K7E8"};